import _ from 'lodash'

export const areEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps.rowContent, nextProps.rowContent)
}

export const mapMaker = (headers, keys) => {
  const returnable = []
  headers.forEach((element, index) => {
    returnable.push([element, keys[index]])
  })
  return new Map(returnable)
}
